"use client";

import {useMemo, useState} from "react";

/** Keep JSON serialization and its resulting string scoped to an open disclosure. */
export default function JsonDisclosure({label, value, maxHeight = 240}: {
   label: string;
   value: unknown;
   maxHeight?: number;
}) {
   const [open, setOpen] = useState(false);
   const json = useMemo(() => open ? JSON.stringify(value, null, 2) : undefined, [open, value]);

   return (
      <details className="text-xs text-500" onToggle={(event) => setOpen(event.currentTarget.open)}>
         <summary className="cursor-pointer">{label}</summary>
         {open && <pre className="overflow-auto whitespace-pre-wrap break-all" style={{maxHeight}}>{json}</pre>}
      </details>
   );
}
